import { connect } from 'react-redux'
import Progress, { getProgressType } from './Progress'
import {
  getDailyProgress,
  getProgress,
  setProgressCustomType,
  setProgressPeriod,
  setProgressType,
} from './store/ProgressActions'
import { setOnboardingStatusToActivityData } from '../RegisterUser/store/RegisterUserActions'
import { getDailyProgressSelector } from './store/progressSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import { IStateProps } from '../../components/YumCustomEntry/YumCustomEntry'
import { IOwnProps } from '../../components/YumCustomEntry/YumCustomEntryWrapper'

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IStateProps => {
  const {
    auth: { userDto, userIntegrationScopes },
    progress: { progressType, customType, progressPeriod },
  } = state
  return {
    // @ts-ignore
    progressType,
    customType,
    progressPeriod,
    userDto,
    userIntegrationScopes,
    dailyDiary: getDailyProgressSelector(state, getProgressType(progressType, customType)),
  }
}

const mapDispatchToProps = {
  setProgressType,
  setProgressCustomType,
  setProgressPeriod,
  getProgress,
  setOnboardingStatusToActivityData,
  getDailyProgress,
}

export default connect(mapStateToProps, mapDispatchToProps)(Progress)
